import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  recipientTaxIdentifierLabelCounter: {
    description: 'Read only label with counter for the recipient tax identifier',
    defaultMessage: '{count} Tax {count, plural, one {ID} other {IDs}} added',
    id: 'hrvXpk',
  },
  recipientTaxIdentifierLabelAddButton: {
    description: 'Add button for adding recipient tax identifier',
    defaultMessage: 'Add',
    id: 'mUh9b7',
  },
  recipientTaxIdentifierLabelEditButton: {
    description: 'Edit button for editing recipient tax identifier',
    defaultMessage: 'Edit',
    id: 'VWPZHR',
  },
});
